import { render, staticRenderFns } from "./DocumentsContract.vue?vue&type=template&id=7c9ff336&"
import script from "./DocumentsContract.vue?vue&type=script&lang=js&"
export * from "./DocumentsContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports